import { render, staticRenderFns } from "./CgCredits.vue?vue&type=template&id=7de75ee6"
import script from "./CgCredits.vue?vue&type=script&lang=js"
export * from "./CgCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports